module.exports = __webpack_public_path__ + "img/Ermer-Case-Study-600px.cb421bb4.jpeg";